import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Renderer2 } from '@angular/core';

@Component({
  selector: 'app-nouvelle-demande',
  templateUrl: './nouvelle-demande.component.html',
  styleUrls: ['./nouvelle-demande.component.scss']
})
export class NouvelleDemandeComponent implements OnInit {

  public search: string  = ''
  data: any[] = [];
  data1: any[] = [];
  data2: any[] = [];
  data3: any[] = [];
  data4: any[] = [];
  Desc : boolean  = false;
  Tel : boolean  = false;
  Video : boolean  = false;
  Media : boolean  = false;

  

  
  constructor(private http: HttpClient, private renderer: Renderer2) {}

  ngOnInit() {
    this.http.get('http://localhost:9000/api/get-all-nouvelle-demandes').subscribe((response: any[]) => {
      this.data = response;
    });
    
  }



  openDesc(id: number) {
    this.Tel = false;
    this.Video = false;
    this.Media = false;
    this.Desc = true;
    
    this.http.get(`http://localhost:9000/api/get-nouvelle-demande/${id}`).subscribe((response: any[]) => {
      this.data1 = response;
    });
  }
  
    openTel(id : number) {
      this.Desc = false ;
      this.Video = false ;
      this.Media = false ;
      this.Tel = true ;
      this.http.get(`http://localhost:9000/api/get-nouvelle-demande/${id}`).subscribe((response: any[]) => {
        this.data2 = response;
      });
    }
    openVideo(id : number) {
      this.Tel = false ;
      this.Desc = false ;
      this.Media = false ;
      this.Video = true ;
      this.http.get(`http://localhost:9000/api/get-nouvelle-demande/${id}`).subscribe((response: any[]) => {
        this.data3 = response;
      });
    }
    openMedia(id : number) {
      this.Tel = false ;
      this.Video = false ;
      this.Desc = false ;
      this.Media = true ;
      this.http.get(`http://localhost:9000/api/get-nouvelle-demande/${id}`).subscribe((response: any[]) => {
        this.data4 = response;
      });
    }

    downloadLogo(id: number) {
      this.http.get(`http://localhost:9000/api/download-logo/${id}`, { responseType: 'blob' }).subscribe((blob: Blob) => {
        // Create an object URL for the blob
        const url = window.URL.createObjectURL(blob);
    
        // Create an anchor element for the download
        const a = this.renderer.createElement('a');
        this.renderer.setAttribute(a, 'href', url);
        this.renderer.setAttribute(a, 'download', 'logo.png');
    
        // Trigger a click on the anchor element to initiate the download
        this.renderer.appendChild(document.body, a);
        a.click();
    
        // Clean up by removing the anchor element and releasing the object URL
        this.renderer.removeChild(document.body, a);
        window.URL.revokeObjectURL(url);
      });
    }
    
    
    
    

    downloadProjects(id: number) {
      this.http.get(`http://localhost:9000/api/download-projects-images/${id}`, { responseType: 'blob' }).subscribe((blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'projects.zip';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      });
    }
    
    deleteNouvelleDemande(id: number, i :any) {
      this.http.delete(`http://localhost:9000/api/delete-nouvelle-demande/${id}`).subscribe(
        (response: any) => {
          console.log('Delete response:', response);
         this.data.splice(i,1) ;
        },
        (error) => {
          console.error('Delete error:', error);
        }
      );
    }
    

}
